import { handleHttp, locationHandle } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {
      linkcontainerflag: false
    };
  },
  watch: {
    '$attrs.detail.banner'(val) {
      if (val) {
        this.swiperEl = new Swiper(this.$refs.swipercontainer, {
          initialSlide: 0,
          pagination: {
            el: this.$refs.swiperpage
          },
          autoplay: true,
          observeSlideChildren: true,
          observeParents: true,
          observer: true
        });
      }
    }
  },
  methods: {
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 切换音视频
    showType(val) {
      this.$attrs.detail.currentShowtype = val;
      if (val !== 'banner') {
        this.$api.getUrlByObjectId(this.$attrs.detail[val][0].objectId).then(res => {
          let currenthttp = location.protocol;
          this.$attrs.detail[val + 'url'] = res.http;
        });
      } else {
        this.$refs.videoItem.pause();
        this.$refs.audioItem.pause();
      }
    },
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.popshowflag = false;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    goLocation(url) {
      locationHandle.call(this, this.$attrs.detail, url);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === '是') {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    }
  }
};